

<form [formGroup]="loginForm" (ngSubmit)="onFormSubmit()" class="loginform">

<div class="modal fade" id="loginModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
            <h3 class="form-group-center">Inicio de Sesión</h3>
          <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>-->
        </div>
        <div class="modal-body">
            
                
            <div class="form-group">
            <label for="email">Usuario</label>
            <input type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && fval.email.errors }" placeholder="Ingresar usuario aquí"/>
            <div *ngIf="submitted && fval.email.errors" class="invalid-feedback">
            <div *ngIf="fval.email.errors.required">El usuario es requerido</div>
            <div *ngIf="fval.email.errors.email">Ingrese un usuario válido</div>
            </div>
            </div>
            <div class="form-group">
            <label for="password">Contraseña</label>
            <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && fval.password.errors }" placeholder="Ingresar contraseña aquí" />
            <div *ngIf="submitted && fval.password.errors" class="invalid-feedback">
            <div *ngIf="fval.password.errors.required">La contraseña es requerida</div>
            </div>
            </div>
            <div class="form-group" class="form-group-center">
            
            <div><label for="error" *ngIf="submitted && loginerror" class="invalid-feedback" style="display: block;">Credenciales Inválidas.</label></div>
            </div>
            
        </div>
        <div class="modal-footer">
            <button [disabled]="loading" class="btn btn-success btn-rounded btnNext" >
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                Iniciar Sesión
                </button>
        </div>
      </div>
    </div>
  </div>
</form>